import { CreatorNetworkMessage } from "../models/CreatorNetworkMessage";

export class WebSocketService {
  private static url = "ws://localhost:49152/creator";
  private static ws: WebSocket | null = null;
  private static onMessageHandlers: ((data: any) => void)[] = [];
  private static onCreatorNetworkMessageHandlers: ((
    data: CreatorNetworkMessage
  ) => void)[] = [];
  private static onConnectHandlers: (() => void)[] = [];
  private static onCloseHandlers: (() => void)[] = [];

  private static _isConnected: boolean = false;

  private static clearSubscriptions() {
    this.onMessageHandlers = [];
    this.onCreatorNetworkMessageHandlers = [];
    this.onConnectHandlers = [];
    this.onCloseHandlers = [];
  }

  public static connect() {
    this.ws = new WebSocket(this.url);

    this.ws.onopen = (event) => {
      console.log("WebSocket connected", event);
      this._isConnected = true;
      this.onConnectHandlers.forEach((handler) => handler());
    };

    this.ws.onmessage = (event) => {
      this.onMessageHandlers.forEach((handler) => handler(event.data));
      try {
        const message = JSON.parse(event.data) as CreatorNetworkMessage;
        this.onCreatorNetworkMessageHandlers.forEach((handler) =>
          handler(message)
        );
      } catch (error) {}
    };

    this.ws.onclose = (event) => {
      console.log("WebSocket disconnected", event);
      this.onCloseHandlers.forEach((handler) => handler());
      this._isConnected = false;
      this.ws = null;

      // cleanup events
      this.clearSubscriptions();
    };

    this.ws.onerror = (error) => {
      console.error("WebSocket error:", error);
      this._isConnected = false;
    };
  }

  // Subscribe to messages
  public static onMessage(handler: (data: any) => void) {
    this.onMessageHandlers.push(handler);
  }

  // Unsubscribe from messages
  public static offMessage(handler: (data: any) => void) {
    this.onMessageHandlers = this.onMessageHandlers.filter(
      (h) => h !== handler
    );
  }

  // Subscribe to creator network messages (already casted)
  public static onCreatorNetworkMessage(
    handler: (data: CreatorNetworkMessage) => void
  ) {
    this.onCreatorNetworkMessageHandlers.push(handler);
  }

  // Unsubscribe from creator network messages
  public static offCreatorNetworkMessage(
    handler: (data: CreatorNetworkMessage) => void
  ) {
    this.onCreatorNetworkMessageHandlers =
      this.onCreatorNetworkMessageHandlers.filter((h) => h !== handler);
  }

  public static onConnect(handler: () => void) {
    this.onConnectHandlers.push(handler);
  }

  public static offConnect(handler: () => void) {
    this.onConnectHandlers = this.onConnectHandlers.filter(
      (h) => h !== handler
    );
  }

  public static onClose(handler: () => void) {
    this.onCloseHandlers.push(handler);
  }

  public static offClose(handler: () => void) {
    this.onCloseHandlers = this.onCloseHandlers.filter((h) => h !== handler);
  }

  public static isConnected() {
    return this._isConnected;
  }

  public static disconnect() {
    if (this.ws) {
      this.ws.close();
      return;
    }

    this._isConnected = false;
    this.clearSubscriptions();
  }

  public static sendMessage(message: string) {
    if (!this.ws) return;
    this.ws?.send(message);
  }
}
